import * as React from "react";
// Styles
import { getClassNames, getStyles } from "./ScreenReaderOnly.styles";
/**
 * Component which hides its content from sighted users
 * Use for aria typed attributes
 */ export function ScreenReaderOnly(props) {
    const classNames = getClassNames(getStyles(props.styles));
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames.root
    }, props.children);
}
